export default __webpack_public_path__ + "static/media/bluefly.21b0e39a.png";